import React from "react";
import { useFunnelNavigation } from "../../../hooks/useFunnelNavigation";
import { StepHeader } from "../../common/StepHeader";
import { InfoBox } from "../../common/InfoBox";
import { Footer } from "../../common/Footer";

export function DefaultSplash({ config }) {
  const { nextStep } = useFunnelNavigation();
  const backgroundColor = config.backgroundColor || "bg-gray-100";

  return (
    <div className="flex flex-col min-h-screen relative">
      {/* Main content container */}
      <div className="flex-1 flex flex-col items-center justify-start">
        {/* Image container */}
        {config.imageUrl && (
          <div className="w-full">
            <img
              src={config.imageUrl}
              alt={config.title}
              className="w-full h-auto object-cover"
            />
          </div>
        )}

        {/* Text content container */}
        <div className={`w-full flex-1 py-8 px-8 ${backgroundColor}`}>
          <StepHeader
            title={config.title}
            subtitle={config.subtitle}
            order={config.headerOrder}
          />

          {/* Info box if provided */}
          {config.infoBox && (
            <div className="px-4 mt-4">
              <InfoBox
                variant={config.infoBox.variant}
                icon={config.infoBox.icon}
                title={config.infoBox.title}
                text={config.infoBox.text}
                badge={config.infoBox.badge}
              />
            </div>
          )}
        </div>
        <Footer onClick={nextStep}>{config.buttonText || "Continue"}</Footer>
      </div>
    </div>
  );
}
